import { render, staticRenderFns } from "./cipin.vue?vue&type=template&id=c666dd36&scoped=true&"
import script from "./cipin.vue?vue&type=script&lang=js&"
export * from "./cipin.vue?vue&type=script&lang=js&"
import style1 from "./cipin.vue?vue&type=style&index=1&id=c666dd36&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c666dd36",
  null
  
)

export default component.exports